import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap'
import {
  FaBan,
  FaBandAid,
  FaEdit,
  FaMoneyBillWaveAlt,
  FaPrint,
  FaTrash,
} from 'react-icons/fa'
import { toast } from 'react-toastify'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode'
import './abrecaixa.css'
import SangriaButton from './sangria.jsx'

pdfMake.addVirtualFileSystem(pdfFonts)

function AberturaCaixa() {
  const [formData, setFormData] = useState({
    troco: '',
    data_abertura: '',
    data_fechamento: '',
    usuario_abertura: localStorage.idusuario,
    usuario_fechamento: '',
  })

  const [showModal, setShowModal] = useState(false)
  const [caixas, setCaixas] = useState([])
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false)
  const [randomText, setRandomText] = useState('')
  const [userInput, setUserInput] = useState('')
  const [selectedId, setSelectedId] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    apinode
      .post(`caixa/abrir-caixa/${localStorage.idconta}`, formData)
      .then((response) => {
        console.log('Resposta do servidor:', response.data)
        toast.success(response.data.message)
      })
      .catch((error) => {
        console.error('Erro ao abrir o caixa:', error)
        toast.error(error.message)
      })
  }

  const handleEdit = (id) => {
    console.log(`Editando caixa com ID: ${id}`)
  }

  const handleClose = (id) => {
    const generatedText = generateRandomText()
    setRandomText(generatedText)
    setSelectedId(id)
    setConfirmModalOpen(true) // Abre o modal de confirmação
    setUserInput('')
  }

  const handleConfirmClose = async () => {
    if (userInput === randomText) {
      try {
        console.log(`Fechando caixa com ID: ${selectedId}`)

        // Enviar requisição para a rota fecharCaixa
        await apinode.post(`pedido/fecharCaixa/${localStorage.idconta}`, {
          ID_CX: selectedId,
          USER: localStorage.idusuario, // Assume que o ID do usuário está armazenado em localStorage
        })

        toast.success('Caixa fechado com sucesso!')

        setConfirmModalOpen(false) // Fecha o modal
        handleCloseModal()
        handlePrint(selectedId)
        setUserInput('')
      } catch (error) {
        console.error('Erro ao fechar o caixa:', error)
        alert('Erro ao fechar o caixa. Tente novamente.')
      }
    } else {
      alert(
        'Texto incorreto! Por favor, digite o texto corretamente para confirmar.',
      )
    }
  }

  const handleShowModal = () => {
    setShowModal(true)
    fetchCaixas()
  }

  const generateRandomText = () => {
    const randomText = Math.random().toString(36).substring(2, 8) // Gera uma string aleatória
    return randomText
  }

  const fetchCaixas = () => {
    apinode
      .get(`caixa/listar-caixas/${localStorage.idconta}`)
      .then((response) => {
        setCaixas(response.data)
      })
      .catch((error) => {
        console.error('Erro ao listar os caixas:', error)
        toast.error(error.message)
      })
  }

  const handleCloseModal = () => setShowModal(false)

  // Função para permitir reabrir o PDF armazenado em caso de erro ou outra necessidade
  const reopenPDF = () => {
    const pdfData = localStorage.getItem('lastGeneratedPDF')
    console.log(pdfData)
    if (pdfData) {
      const pdfDocGenerator = pdfMake.createPdf(JSON.parse(pdfData))
      pdfDocGenerator.open() // Abre novamente em uma nova guia
    } else {
      alert('Nenhum PDF encontrado para reabrir.')
    }
  }

  // Function to fetch sales data and generate PDF report
  const handlePrint = (id_cx) => {
    apinode
      .get(`pedido/listardadoscaixa/${id_cx}/${localStorage.idconta}`)
      .then((response) => {
        const salesData = response.data.dadosCaixa
        const dataCX = response.data.dataCaixa

        // Agrupar por ID do Pedido e separar por formas de pagamento
        const groupedSales = salesData.reduce((acc, sale) => {
          const existingSale = acc.find(
            (item) => item.idpedido === sale.idpedido,
          )

          if (existingSale) {
            // Se já existe, apenas adiciona os dados de forma de pagamento com valor específico
            existingSale.formasPagamento.push({
              formaPgto: sale.forma_pgto,
              valorPedido: sale.valorpedido,
              vlrRecebido: sale.vlr_recebido,
            })
          } else {
            // Caso contrário, cria uma nova entrada para o pedido
            acc.push({
              idpedido: sale.idpedido,
              cliente: sale.cliente,
              formasPagamento: [
                {
                  formaPgto: sale.forma_pgto,
                  valorPedido: sale.valorpedido,
                  vlrRecebido: sale.vlr_recebido,
                },
              ],
            })
          }
          return acc
        }, [])

        // Calcular o total de vendas (valorPedido) sem repetir para o mesmo ID de pedido
        const totalSales = groupedSales.reduce(
          (total, sale) => total + sale.formasPagamento[0].valorPedido,
          0,
        )

        // Calcular o total recebido (vlrRecebido)
        const totalReceived = groupedSales.reduce(
          (total, sale) =>
            total +
            sale.formasPagamento.reduce(
              (sum, payment) => sum + payment.vlrRecebido,
              0,
            ),
          0,
        )

        // Agrupar totais por forma de pagamento
        const paymentSummary = salesData.reduce((summary, sale) => {
          if (!summary[sale.forma_pgto]) {
            summary[sale.forma_pgto] = 0
          }
          summary[sale.forma_pgto] += sale.vlr_recebido
          return summary
        }, {})

        // Calcular o subtotal (incluindo valores negativos)
        const subtotalPayments = Object.values(paymentSummary).reduce(
          (sum, value) => sum + value,
          0,
        )

        const initialCash = salesData[0]?.fundo_caixa // Assuming fundo_caixa is the same for all records
        const subtotal = totalSales + parseFloat(initialCash) // Subtotal = Total de Vendas + Fundo de Caixa
        const openingName = salesData[0]?.nome_abertura || 'N/A' // Nome da pessoa que abriu o caixa

        // Define PDF structure
        const docDefinition = {
          content: [
            { text: 'Relatório de Fechamento de Caixa', style: 'header' },
            { text: `ID do Caixa: ${id_cx}`, style: 'subheader' },
            {
              text: `Data: ${new Date(dataCX).toLocaleDateString('pt-BR')}`,
              style: 'subheader',
            },

            // Exibindo os campos no cabeçalho com dados da tabela
            {
              columns: [
                {
                  text: `Fundo de Caixa: R$ ${initialCash?.toFixed(2)}`,
                  style: 'info',
                },
                { text: `Usua.Abertura: ${openingName}`, style: 'info' },
                {
                  text: `Total de Vendas: R$ ${totalSales?.toFixed(2)}`,
                  style: 'info',
                },
                {
                  text: `Subtotal Final: R$ ${subtotal?.toFixed(2)}`,
                  style: 'info',
                },
              ],
              columnGap: 10, // Diminuindo o espaço entre as colunas
            },

            { text: '\n' },

            // Relatório em formato de tabela matricial
            {
              table: {
                headerRows: 1,
                widths: [80, '*', 120, 100, 100], // Ajuste das larguras das colunas
                body: [
                  [
                    { text: 'ID Pedido', style: 'tableHeader' },
                    { text: 'Cliente', style: 'tableHeader' },
                    { text: 'Forma de Pagamento', style: 'tableHeader' },
                    { text: 'Valor Pedido', style: 'tableHeader' },
                    { text: 'Vlr Recebido', style: 'tableHeader' },
                  ],
                  ...groupedSales.flatMap((sale) =>
                    sale.formasPagamento.map((payment) => [
                      { text: sale.idpedido, style: 'tableCell' },
                      { text: sale.cliente, style: 'tableCell' },
                      { text: payment.formaPgto, style: 'tableCell' },
                      {
                        text: `R$ ${payment.valorPedido?.toFixed(2)}`,
                        style: 'tableCell',
                      },
                      {
                        text: `R$ ${payment.vlrRecebido?.toFixed(2)}`,
                        style: 'tableCell',
                      },
                    ]),
                  ),
                ],
              },
              layout: 'lightHorizontalLines',
            },

            { text: '\n' },

            // Resumo de pagamentos com subtotal destacado
            {
              text: 'Resumo por Forma de Pagamento:',
              style: 'subheader',
            },
            {
              ul: Object.entries(paymentSummary).map(
                ([formaPgto, total]) =>
                  `• ${formaPgto}: R$ ${total?.toFixed(2)}`,
              ),
            },
            { text: '\n' },
            // Linha de separação para destaque
            {
              canvas: [
                { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
              ],
            },
            {
              text: `Subtotal: R$ ${subtotalPayments.toFixed(2)}`,
              style: 'subtotalHighlight',
            },
          ],
          styles: {
            header: { fontSize: 10, bold: true, alignment: 'center' },
            subheader: { fontSize: 8, margin: [0, 5, 0, 2] },
            info: {
              fontSize: 8,
              margin: [5, 5, 5, 5],
              bold: true,
              alignment: 'center',
            },
            tableHeader: {
              bold: true,
              fontSize: 8,
              color: 'black',
              alignment: 'center',
            },
            tableCell: { fontSize: 8, alignment: 'left', margin: [1, 2, 1, 2] },
            subtotalHighlight: {
              fontSize: 9,
              bold: true,
              color: 'red',
              alignment: 'center',
              margin: [0, 5, 0, 0],
            },
          },
          pageMargins: [20, 20, 20, 20], // Margens mais estreitas
        }

        // Gerar e abrir o PDF
        pdfMake.createPdf(docDefinition).open()
      })
      .catch((error) => {
        console.error('Erro ao gerar o relatório de caixa:', error)
        toast.error(error.message)
      })
  }

  return (
    <>
      <Navbar />
      <Container className="mt-page">
        <Row className="justify-content-center">
          <Col md={6}>
            <Card className="shadow-lg p-4">
              <Card.Body>
                <h3 className="text-center mb-4">Abertura de Caixa</h3>
                <Form onSubmit={handleSubmit}>
                  <Form.Group controlId="formIdCx">
                    <Form.Label>Troco</Form.Label>
                    <Form.Control
                      type="text"
                      name="troco"
                      placeholder="Digite o fundo de caixa (troco)"
                      value={formData.troco}
                      onChange={handleChange}
                      required
                      className="mb-3"
                    />
                  </Form.Group>
                  <Form.Group controlId="formDataAbertura">
                    <Form.Label>Data de Abertura</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      name="data_abertura"
                      value={formData.data_abertura}
                      onChange={handleChange}
                      required
                      className="mb-3"
                    />
                  </Form.Group>
                  <Form.Group controlId="formUsuarioAbertura">
                    <Form.Label>Usuário de Abertura</Form.Label>
                    <Form.Control
                      type="text"
                      name="usuario_abertura"
                      value={formData.usuario_abertura}
                      onChange={handleChange}
                      required
                      className="mb-3"
                      disabled
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                  >
                    Abrir Caixa
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={handleShowModal}
                    className="mt-3 w-100"
                  >
                    Listar Caixas
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="lg"
          dialogClassName="custom-modalzpl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Listagem de Caixas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Caixas Abertos e Fechados</h5>
            <table
              className="table"
              style={{ fontSize: '12px' }}
            >
              <thead>
                <tr>
                  <th>ID do Caixa</th>
                  <th>Data de Abertura</th>
                  <th>Data de Fechamento</th>
                  <th>Usuário de Abertura</th>
                  <th>Usuário de Fechamento</th>
                  <th>Fundo de Caixa</th>
                  {/* <th>Nome do Funcionário</th> */}
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {caixas.length > 0 ? (
                  caixas.map((caixa) => (
                    <tr key={caixa.id_cx}>
                      <td>{caixa.id_cx}</td>
                      <td>{new Date(caixa.data_abertura).toLocaleString()}</td>
                      <td>
                        {caixa.data_fechamento ? (
                          new Date(caixa.data_fechamento).toLocaleString()
                        ) : (
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '4px 8px',
                              fontSize: '12px',
                              color: '#fff',
                              backgroundColor: '#28a745', // Verde
                              borderRadius: '5px',
                            }}
                          >
                            Aberto
                          </span>
                        )}
                      </td>

                      <td>{caixa.nome_usuario_abertura}</td>
                      <td>{caixa.fechamento || 'N/A'}</td>
                      <td>
                        {caixa.fundo_caixa.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </td>

                      <td>
                        <ButtonGroup>
                          <OverlayTrigger
                            overlay={<Tooltip>Editar Caixa</Tooltip>}
                          >
                            <button
                              onClick={() => handleEdit(caixa.id_cx)}
                              style={{
                                marginRight: '5px',
                                fontSize: '10px',
                                cursor: 'pointer',
                              }}
                            >
                              <FaEdit />
                            </button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            overlay={<Tooltip>Fechar Caixa</Tooltip>}
                          >
                            <button
                              onClick={() => handleClose(caixa.id_cx)}
                              style={{ fontSize: '10px', cursor: 'pointer' }}
                              disabled={caixa.data_fechamento !== null} // Verifica se o caixa já foi fechado
                            >
                              <FaBan />
                            </button>
                          </OverlayTrigger>
                          <OverlayTrigger overlay={<Tooltip>Imprimir</Tooltip>}>
                            <button
                              onClick={() => handlePrint(caixa.id_cx)}
                              style={{ fontSize: '10px', cursor: 'pointer' }}
                            >
                              <FaPrint />
                            </button>
                          </OverlayTrigger>

                          <SangriaButton
                            idCx={caixa.id_cx}
                            data_fx={caixa.data_fechamento}
                          />

                          <OverlayTrigger
                            overlay={
                              <Tooltip id="tooltip-reimprimir">
                                Reimprimir o último PDF gerado
                              </Tooltip>
                            }
                          >
                            <button
                              onClick={() => reopenPDF()}
                              style={{
                                fontSize: '12px', // Aumentei o tamanho da fonte para melhorar a legibilidade
                                cursor: 'pointer',
                                background: 'transparent', // Melhor aparência de um botão com estilo limpo
                                border: 'none',
                                padding: '5px',
                                borderRadius: '5px',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)', // Uma leve sombra para melhorar o foco
                              }}
                              disabled={caixa.data_fechamento !== null} // Botão desabilitado se o caixa já foi fechado
                            >
                              <FaPrint
                                color={
                                  caixa.data_fechamento !== null
                                    ? 'gray'
                                    : '#007bff'
                                }
                              />{' '}
                              {/* Muda a cor do ícone quando desabilitado */}
                            </button>
                          </OverlayTrigger>

                          {/*
                          <OverlayTrigger overlay={<Tooltip>Sangria</Tooltip>}>
                            <button onClick={() => handleSangria(caixa.id_cx)} style={{ fontSize: '10px', cursor: 'pointer' }}>
                              <FaMoneyBillWaveAlt />
                            </button>
                          </OverlayTrigger> */}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      className="text-center"
                    >
                      Nenhum caixa encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleCloseModal}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de Confirmação */}
        <Modal
          show={isConfirmModalOpen}
          onHide={() => setConfirmModalOpen(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmação de Fechamento de Caixa</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Para confirmar o fechamento do caixa, digite o seguinte texto:
            </p>
            <h4>{randomText}</h4>
            <Form.Control
              type="text"
              placeholder="Digite o texto acima"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setConfirmModalOpen(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={handleConfirmClose}
            >
              Confirmar Fechamento
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  )
}

export default AberturaCaixa
